import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ThreeTwoOneMethodView" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("計算")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("リセット")
const _hoisted_4 = { class: "ThreeTwoOneMethodView-Table" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th"),
  /*#__PURE__*/_createElementVNode("th", null, "1週目"),
  /*#__PURE__*/_createElementVNode("th", null, "2週目"),
  /*#__PURE__*/_createElementVNode("th", null, "3週目"),
  /*#__PURE__*/_createElementVNode("th", null, "4週目")
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

import UITitle from "../components/ui/UITitle.vue";
import UIExplain from "../components/ui/UIExplain.vue";
import UIInput from "../components/ui/UIInput.vue";
import UIFlexBox from "../components/ui/UIFlexBox.vue";
import UIButton from "../components/ui/UIButton.vue";
import UIHint from "../components/ui/UIHint.vue";

import { ref, Ref, reactive, computed } from "vue";

type menu = {
	id: string;
	number: number;
	percentage1: number;
	count1: number;
	percentage2: number;
	count2: number;
	percentage3: number;
	count3: number;
	percentage4: number;
	count4: number;
	isAdditionalCount: boolean;
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const weight: Ref<number | any> = ref(null);

const state = reactive({
	isCalculated: false,
	isCalculateAvailable: false,
	isInterval: false,
});

const calcWeight = (percentage: number) => {
	const result: number = Math.round(Number(weight.value) * (percentage / 100));
	return result;
};

const onClickCalc = () => {
	state.isCalculated = true;
	state.isInterval = true;
};

const onClickReset = () => {
	weight.value = null;
	state.isCalculated = false;
	state.isInterval = false;
};

const isCheckCalculateAvailable = computed(() => {
	return weight.value > 0 && !state.isInterval ? true : false;
});

const isCheckResetAvailable = computed(() => {
	return state.isCalculated ? true : false;
});

const title = "531プログラム";
const explain =
	"日々の体調の揺れに対応できるプログラムです。忙しい中しっかり鍛えたい方にピッタリ。";

const menuList: menu[] = [
	{
		id: "1",
		number: 1,
		percentage1: 65,
		count1: 5,
		percentage2: 70,
		count2: 3,
		percentage3: 75,
		count3: 5,
		percentage4: 40,
		count4: 5,
		isAdditionalCount: false,
	},
	{
		id: "2",
		number: 2,
		percentage1: 75,
		count1: 5,
		percentage2: 80,
		count2: 3,
		percentage3: 85,
		count3: 3,
		percentage4: 50,
		count4: 5,
		isAdditionalCount: false,
	},
	{
		id: "3",
		number: 3,
		percentage1: 85,
		count1: 5,
		percentage2: 90,
		count2: 3,
		percentage3: 95,
		count3: 1,
		percentage4: 60,
		count4: 5,
		isAdditionalCount: true,
	},
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UITitle, {
      title: title,
      titleType: "normal"
    }),
    _createVNode(UIExplain, { explain: explain }),
    _createVNode(UIInput, {
      modelValue: weight.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((weight).value = $event)),
      isInterval: _unref(state).isInterval
    }, null, 8, ["modelValue", "isInterval"]),
    _createVNode(UIHint, {
      isCheckCalculateAvailable: _unref(isCheckCalculateAvailable),
      isCheckResetAvailable: _unref(isCheckResetAvailable),
      isInterval: _unref(state).isInterval
    }, null, 8, ["isCheckCalculateAvailable", "isCheckResetAvailable", "isInterval"]),
    _createVNode(UIFlexBox, null, {
      default: _withCtx(() => [
        _createVNode(UIButton, {
          onClick: onClickCalc,
          disabled: !_unref(isCheckCalculateAvailable),
          size: "small"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(UIButton, {
          onClick: onClickReset,
          disabled: !_unref(isCheckResetAvailable),
          size: "small"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }),
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("tbody", null, [
        _hoisted_5,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (menu, index) => {
          return _createElementVNode("tr", { key: index }, [
            _createElementVNode("th", null, _toDisplayString(menu.number) + "セット目", 1),
            _createElementVNode("td", null, [
              (!_unref(state).isCalculated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(menu.percentage1) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(calcWeight(menu.percentage1)) + "kg", 1)),
              _createTextVNode(" x " + _toDisplayString(menu.count1) + "回", 1),
              (menu.isAdditionalCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "+α"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (!_unref(state).isCalculated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(menu.percentage2) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(calcWeight(menu.percentage2)) + "kg", 1)),
              _createTextVNode(" x " + _toDisplayString(menu.count2) + "回", 1),
              (menu.isAdditionalCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "+α"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (!_unref(state).isCalculated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(menu.percentage3) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(calcWeight(menu.percentage3)) + "kg", 1)),
              _createTextVNode(" x " + _toDisplayString(menu.count3) + "回", 1),
              (menu.isAdditionalCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "+α"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (!_unref(state).isCalculated)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(menu.percentage4) + "%", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(calcWeight(menu.percentage4)) + "kg", 1)),
              _createTextVNode(" x " + _toDisplayString(menu.count4) + "回 ", 1)
            ])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})